import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
} from '@angular/common/http';

@Injectable()
export class FileUploadInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Check if this is a file upload request
    const isFileUpload =
      req.method === 'POST' &&
      ((req.url.includes('/nodes/') && req.url.includes('/children')) ||
        req.url.includes('/import') ||
        req.url.includes('/s/wk/nodes/'));

    if (isFileUpload && req.body instanceof FormData) {
      // Remove content-type header to let browser set multipart/form-data with boundary
      const headers = req.headers.delete('Content-Type');
      const modifiedReq = req.clone({ headers });

      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
